"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { useAnalytics } from "@/lib/analytics";
import type { CustomerIOProvider } from "@/lib/analytics/providers/customer-io-provider";
import { isPublicCreatorRoute } from "@/lib/analytics/posthogFeatureFlags";

/**
 * Customer.io in-app page rules need page() calls on SPA route changes.
 * Keep this centralized so client-side navigation stays message-aware.
 */
export function CustomerIOPageTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { getAnalyticsManager } = useAnalytics();
  const search = searchParams.toString();

  useEffect(() => {
    if (isPublicCreatorRoute(pathname)) return;
    let active = true;
    const manager = getAnalyticsManager();

    void manager
      .initialize()
      .then(() => {
        if (active) return manager.getProvider<CustomerIOProvider>("customerio")?.page();
      })
      .catch((error) => {
        console.error("[Customer.io] Failed to track page change", error);
      });
    return () => {
      active = false;
    };
  }, [getAnalyticsManager, pathname, search]);

  return null;
}
